
import { defineComponent } from 'vue'
import { useSession } from '@/composables/auth'
export default defineComponent({
  setup() {
    let { user } = useSession()
    return {
      user
    }
  },
  computed: {
    userFullName(): string {
      return this.user.first_name + ' ' + this.user.last_name
    },
    lastLoginDate(): string {
      if (this.user.last_login) {
        const date = new Date(this.user.last_login)
        const d = date.toLocaleString()
        return d
      } else return ''
    },
    userLicense(): string {
      return this.user.company ? this.$t('user-license.pro') : this.$t('user-license.individual')
    }
  }
})
